import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faTrophy } from "@fortawesome/pro-regular-svg-icons/faTrophy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CloseIcon from '@mui/icons-material/Close';
import { createStyles, Grid, Theme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SnackbarContent, { SnackbarContentProps } from '@mui/material/SnackbarContent';
import { withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";

const variantIcon = {
    success: faInfoCircle,
    warning: faExclamationTriangle,
    error: faExclamationCircle,
    info: faCheckCircle,
    trophy: faTrophy,
};

const styles = (theme: Theme) => createStyles({
    success: {
        backgroundColor: theme.genie.palette.success.main,
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.genie.palette.info.main,
    },
    warning: {
        backgroundColor: theme.genie.palette.warning.main,
    },
    trophy: {
        backgroundColor: theme.genie.palette.warning.dark,
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(),
    }
});

interface IProps {
    variant: MuiSnackbarVariant;
    onClose?: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
};

export type MuiSnackbarVariant = "info" | "success" | "warning" | "error" | "trophy";

export type MuiSnackbarContentProps = IProps & Omit<SnackbarContentProps, "variant">;

type Props = MuiSnackbarContentProps & WithStyles<typeof styles>;

const MuiSnackbarContent: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (props, ref) => {
    const { classes, className, message, action, onClose, variant, ...other } = props;
    return (
        <SnackbarContent
            ref={ref}
            className={classNames(classes[variant], className)}
            message={
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <FontAwesomeIcon className={classNames(classes.icon, classes.iconVariant)} icon={variantIcon[variant]} />
                    </Grid>
                    <Grid item xs>
                        {message}
                    </Grid>
                </Grid>
            }
            action={
                [
                    action,
                    onClose == null
                        ? null
                        : <IconButton
                            key="close"
                            color="inherit"
                            onClick={onClose}
                        >
                            <CloseIcon className={classes.icon} />
                        </IconButton>
                ]
            }

            {...other}
        />

    );
};

const MuiSnackbarForwaredRefComponent = React.forwardRef(MuiSnackbarContent);

export default withStyles(styles)(MuiSnackbarForwaredRefComponent);
